export function filterSelectOptionWithTag(
  option: SelectOption & { data: Record<string, any> },
  filterString: string
): boolean {
  if (filterString) {
    return (
      option.data.label.toLowerCase().includes(filterString.toLowerCase()) ||
      option.data.tag.label.toLowerCase().includes(filterString.toLowerCase())
    );
  }

  return true;
}
